/* eslint-disable react/prop-types */
// Inline SVG flags — render identically on Windows/Edge (which lacks emoji flag glyphs).

export const FlagIT = ({ className = "" }) => (
  <svg
    viewBox="0 0 30 20"
    className={className}
    aria-hidden="true"
    role="img"
  >
    <rect width="10" height="20" fill="#009246" />
    <rect x="10" width="10" height="20" fill="#fff" />
    <rect x="20" width="10" height="20" fill="#CE2B37" />
  </svg>
);

export const FlagGB = ({ className = "" }) => (
  <svg
    viewBox="0 0 60 30"
    className={className}
    aria-hidden="true"
    role="img"
  >
    <clipPath id="afb-gb-clip">
      <path d="M0,0 v30 h60 v-30 z" />
    </clipPath>
    <clipPath id="afb-gb-clip2">
      <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
    </clipPath>
    <g clipPath="url(#afb-gb-clip)">
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        clipPath="url(#afb-gb-clip2)"
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </g>
  </svg>
);
